<button class="{{ additionalClass }}" [ngClass]="dynamicClass" mat-button type="button" [attr.style]="styles" [attr.aria-label]="ariaLabel || null" [attr.aria-haspopup]="ariaHaspopup" [attr.aria-pressed]="ariaPressed" [disabled]="!!disabled" (click)="trackButton()">
  @if (matIcon) {
    <mat-icon>{{ matIcon }}</mat-icon>
  }
  <ng-content></ng-content>
</button>
